import classNames from "classnames";
import {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useLayoutEffect,
} from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../contexts/authContext";
import { authPagesMenu } from "../../menu";
import { IPageProps } from "../Page/Page";
import { ISubHeaderProps } from "../SubHeader/SubHeader";

interface IPageWrapperProps {
  isProtected?: boolean;
  title?: string;
  description?: string;
  children:
    | ReactElement<ISubHeaderProps>[]
    | ReactElement<IPageProps>
    | ReactElement<IPageProps>[];
  className?: string;
}
const PageWrapper = forwardRef<HTMLDivElement, IPageWrapperProps>(
  ({ isProtected = true, title, description, className, children }, ref) => {
    useLayoutEffect(() => {
      // @ts-ignore
      document.getElementsByTagName("TITLE")[0].text =
        `${title ? `${title} | ` : ""}${process.env.REACT_APP_SITE_NAME}`;
      // @ts-ignore
      document
        ?.querySelector('meta[name="description"]')
        .setAttribute(
          "content",
          description || process.env.REACT_APP_META_DESC || "",
        );
    });

    const { user } = useContext(AuthContext);

    const navigate = useNavigate();
    useEffect(() => {
      if (isProtected && user === "") {
        navigate(`../${authPagesMenu.login.path}`);
      }
      return () => {};
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <div
        ref={ref}
        className={classNames("page-wrapper", "container-fluid", className)}
      >
        {children}
      </div>
    );
  },
);
PageWrapper.displayName = "PageWrapper";

export default PageWrapper;
